import { useState } from 'react';
import type { ReactNode } from 'react';

import {
  HStack,
  SearchInput,
  SearchInputField,
} from '@frontend/legacy-components';

import { Filters } from './components';

export type SearchAndFiltersProps = {
  filtersContent: ReactNode;
  inputPlaceholder: string;
  onSearch: (search?: string | undefined) => void;
  searchValue: string;
};

export const SearchAndFilters = ({
  filtersContent,
  inputPlaceholder,
  onSearch,
  searchValue,
}: SearchAndFiltersProps) => {
  const [value, setValue] = useState(searchValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setValue(e.target.value);

  const handleClear = () => {
    onSearch('');
    setValue('');
  };

  const handleSearch = () => onSearch(value);

  return (
    <HStack flex="1 1 100%">
      <SearchInput
        flexShrink={1}
        flexBasis={70}
        mode="submit"
        size="lg"
        onChange={handleChange}
        onClear={handleClear}
        onSubmit={handleSearch}
        value={value}
      >
        <SearchInputField placeholder={inputPlaceholder} />
      </SearchInput>
      <Filters content={filtersContent} />
    </HStack>
  );
};
